import React from 'react';
import './footer.css';
import logo from '../../assets/tapngo.png';
import { Link } from 'react-router-dom';
import { NEWS_URL } from '../../utils';
import qrCode from '../../assets/commuter-qr.png';
import appstore from '../../assets/appstore.png';
import playstore from '../../assets/playstore.png';
import ussd from '../../assets/ussd.png';
import Web from './Web';

// Footer links switch pages in-app, which keeps the scroll position, so
// without this the new page would open scrolled to its bottom
function scrollToTop() {
  window.scrollTo(0, 0);
}

function FooterSection() {
  return (
    <footer
      id="footer"
      class="flex flex-col justify-center items-start md:items-center bg-black h-fit gap-8 py-8 md:py-12 px-4 md:px-6 lg:px-12"
      aria-labelledby="footer-heading"
    >
      <div className="w-full" style={{ maxWidth: '1184px' }}>
        {/* top row */}
        <div className="top-row flex flex-col items-start md:flex-row md:gap-40 lg:gap-40 xl:gap-52 w-full">
          <div className="logo flex flex-col gap-8">
            <div
              className="w-12"
              onClick={() => {
                window.scrollTo({ top: (0, 0), behavior: 'smooth' });
              }}
            >
              <img
                className="w-full object-cover"
                src={logo}
                alt="tap n' go logo"
              />
            </div>
            <div className="language flex gap-1 justify-center items-center bg-white rounded-full px-3 py-2">
              <Web />
              <span className="text-base font-bold text-black">English</span>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 mt-24 md:mt-auto lg:grid-cols-3 justify-evenly items-start gap-y-5 gap-x-20 md:gap-y-10 md:gap-x-24 lg:gap-52 text-black pr-10">
            <ul className="flex flex-col justify-center items-start gap-y-2">
              <h2 className="text-xl font-bold">Support</h2>
              <li className="text-base whitespace-nowrap">
                <Link to="/faqs" onClick={scrollToTop}>FAQs</Link>
              </li>
              <li className="text-base whitespace-nowrap">
                <Link to="/how-it-works">How it works</Link>
              </li>
              <li className="text-base whitespace-nowrap">
                <Link to="/merchants" onClick={scrollToTop}>Merchants</Link>
              </li>
              <li className="text-base whitespace-nowrap">
                <Link to="/customer-feedback" onClick={scrollToTop}>
                  Customer Feedback
                </Link>
              </li>
            </ul>
            <ul className="flex flex-col justify-center items-start gap-y-2">
              <h2 className="text-xl font-bold whitespace-nowrap">
                Quick Links
              </h2>
              <li className="text-base whitespace-nowrap">
                <Link to="/partners" onClick={scrollToTop}>Partners</Link>
              </li>
              <li className="text-base whitespace-nowrap">
                <a href={NEWS_URL}>News</a>
              </li>
              <li className="text-base whitespace-nowrap">
                <Link to="/about" onClick={scrollToTop}>About Tap n' Go</Link>
              </li>
            </ul>
            <ul className="flex flex-col justify-center items-start gap-y-2">
              <h2 className="text-xl font-bold">Legal</h2>
              <li className="text-base whitespace-nowrap">
                <Link to="/privacy" onClick={scrollToTop}>Privacy</Link>
              </li>
              <li className="text-base whitespace-nowrap">
                <Link to="/terms" onClick={scrollToTop}>Terms</Link>
              </li>
            </ul>
          </div>
        </div>

        {/* copyright */}
        <div className="copyright flex flex-col-reverse md:flex-row justify-between items-center gap-5 w-full mt-12 pt-8 md:pt-10">
          <p className="font-light text-xs m-0 text-center lg:text-left  text-white">
            &copy; {new Date().getFullYear()} Transport for Ghana, All rights
            reserved.
          </p>

          {/* socials */}
          <div className="flex flex-col justify-center lg:items-end">
            <div class="flex justify-center lg:justify-end items-center gap-8 w-52">
              <a
                href="https://www.facebook.com/people/Tap-n-Go-Ghana/61551821461698/"
                target="_blank"
                rel="noreferrer"
                class="text-white hover:text-gray-400"
              >
                <span class="sr-only">Facebook</span>
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="36" height="36" rx="18" fill="white" />
                  <path
                    d="M17.999 8C12.477 8 8 12.477 8 17.999C8 22.989 11.656 27.125 16.437 27.878V20.89H13.897V17.999H16.437V15.796C16.437 13.288 17.93 11.905 20.213 11.905C21.307 11.905 22.453 12.1 22.453 12.1V14.559H21.189C19.949 14.559 19.561 15.331 19.561 16.122V17.997H22.332L21.889 20.888H19.561V27.876C24.342 27.127 27.998 22.99 27.998 17.999C27.998 12.477 23.521 8 17.999 8Z"
                    fill="#030F1A"
                  />
                </svg>
              </a>

              <a
                href="https://www.instagram.com/tapngogh"
                target="_blank"
                rel="noreferrer"
                class="text-white hover:text-gray-400"
              >
                <span class="sr-only">Instagram</span>
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="36" height="36" rx="18" fill="white" />
                  <path
                    d="M20.9972 17.9796C20.9972 19.6381 19.6527 20.9826 17.9942 20.9826C16.3357 20.9826 14.9912 19.6381 14.9912 17.9796C14.9912 16.3211 16.3357 14.9766 17.9942 14.9766C19.6527 14.9766 20.9972 16.3211 20.9972 17.9796Z"
                    fill="#030F1A"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M26.5281 12.0885C26.7952 12.7972 26.937 13.5471 26.9471 14.3045C27.0028 15.2571 27.0031 15.5686 27.005 17.9798L27.0051 18.0134C27.0051 20.4564 26.9921 20.7614 26.9491 21.7234C26.9341 22.4724 26.7931 23.2104 26.5301 23.9104C26.2982 24.5081 25.9442 25.0509 25.4909 25.5043C25.0376 25.9576 24.4948 26.3116 23.8971 26.5434C23.1974 26.806 22.4582 26.9477 21.7111 26.9624C20.7561 27.0184 20.4431 27.0184 18.0011 27.0184C15.5591 27.0184 15.2541 27.0054 14.2911 26.9624C13.5424 26.9378 12.8035 26.7856 12.1061 26.5124C11.5081 26.281 10.9651 25.9274 10.5115 25.4742C10.058 25.021 9.70395 24.4782 9.47207 23.8804C9.20907 23.1794 9.06807 22.4414 9.05307 21.6934C8.99707 20.7374 8.99707 20.4254 8.99707 17.9834C8.99707 15.5415 9.01007 15.2365 9.05307 14.2735C9.06719 13.5266 9.2089 12.7876 9.47207 12.0885C9.70356 11.4905 10.0573 10.9475 10.5107 10.4941C10.9641 10.0407 11.5071 9.68696 12.1051 9.45547C12.8044 9.19294 13.5432 9.05092 14.2901 9.03547C15.2451 8.98047 15.5581 8.98047 18.0001 8.98047C20.4421 8.98047 20.7471 8.99247 21.7091 9.03547C22.4562 9.05081 23.1954 9.19283 23.8951 9.45547C24.4929 9.68712 25.0359 10.0409 25.4892 10.4943C25.9426 10.9477 26.2964 11.4906 26.5281 12.0885ZM13.3711 17.9784C13.3711 20.5324 15.4401 22.6014 17.9941 22.6014C19.2202 22.6014 20.396 22.1144 21.263 21.2474C22.13 20.3804 22.6171 19.2045 22.6171 17.9784C22.6171 16.7523 22.13 15.5765 21.263 14.7095C20.396 13.8425 19.2202 13.3555 17.9941 13.3555C15.4401 13.3555 13.3711 15.4245 13.3711 17.9784ZM22.3884 14.1807C22.5192 14.2348 22.6595 14.2626 22.8011 14.2625C23.3961 14.2625 23.8781 13.7805 23.8781 13.1845C23.8781 13.043 23.8502 12.9028 23.7961 12.7721C23.7419 12.6414 23.6625 12.5226 23.5625 12.4226C23.4624 12.3225 23.3436 12.2431 23.2129 12.189C23.0822 12.1348 22.9421 12.107 22.8006 12.107C22.6591 12.107 22.519 12.1348 22.3882 12.189C22.2575 12.2431 22.1387 12.3225 22.0387 12.4226C21.9386 12.5226 21.8592 12.6414 21.8051 12.7721C21.7509 12.9028 21.7231 13.043 21.7231 13.1845C21.7229 13.3261 21.7507 13.4663 21.8049 13.5972C21.859 13.728 21.9384 13.8469 22.0385 13.947C22.1386 14.0471 22.2575 14.1265 22.3884 14.1807Z"
                    fill="#030F1A"
                  />
                </svg>
              </a>

              <a
                href="https://twitter.com/tapngogh"
                target="_blank"
                rel="noreferrer"
                class="text-white hover:text-gray-400"
              >
                <span class="sr-only">Twitter</span>
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="36" height="36" rx="18" fill="white" />
                  <path
                    d="M25.633 13.9975C25.646 14.1725 25.646 14.3465 25.646 14.5205C25.646 19.8456 21.593 25.9816 14.186 25.9816C11.904 25.9816 9.784 25.3206 8 24.1726C8.324 24.2096 8.636 24.2226 8.973 24.2226C10.786 24.227 12.5476 23.6207 13.974 22.5016C13.1334 22.4864 12.3186 22.209 11.6432 21.7083C10.9679 21.2076 10.4658 20.5085 10.207 19.7086C10.456 19.7456 10.706 19.7706 10.968 19.7706C11.329 19.7706 11.692 19.7206 12.029 19.6336C11.1168 19.4494 10.2965 18.9549 9.70762 18.2343C9.11876 17.5136 8.79769 16.6112 8.799 15.6805V15.6305C9.336 15.9295 9.959 16.1166 10.619 16.1416C10.0661 15.7741 9.61272 15.2756 9.29934 14.6903C8.98596 14.1051 8.82231 13.4514 8.823 12.7875C8.823 12.0395 9.022 11.3535 9.371 10.7555C10.3831 12.0006 11.6455 13.0191 13.0763 13.7452C14.5072 14.4713 16.0746 14.8888 17.677 14.9705C17.615 14.6705 17.577 14.3595 17.577 14.0475C17.5767 13.5185 17.6807 12.9946 17.8831 12.5058C18.0854 12.017 18.3821 11.5728 18.7562 11.1987C19.1303 10.8246 19.5744 10.5279 20.0632 10.3256C20.5521 10.1233 21.076 10.0193 21.605 10.0195C22.765 10.0195 23.812 10.5055 24.548 11.2915C25.4498 11.1172 26.3145 10.788 27.104 10.3185C26.8034 11.2494 26.1738 12.0386 25.333 12.5385C26.1328 12.4473 26.9144 12.237 27.652 11.9145C27.1011 12.7176 26.4185 13.4219 25.633 13.9975Z"
                    fill="#030F1A"
                  />
                </svg>
              </a>

              <a
                href="https://github.com/Transport-For-Ghana"
                target="_blank"
                rel="noreferrer"
                class="text-white hover:text-gray-400"
              >
                <span class="sr-only">GitHub</span>
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="36" height="36" rx="18" fill="white" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M18 8C12.477 8 8 12.484 8 18.017C8 22.442 10.865 26.197 14.839 27.521C15.339 27.613 15.521 27.304 15.521 27.038C15.521 26.801 15.513 26.17 15.508 25.335C12.726 25.94 12.139 23.992 12.139 23.992C11.685 22.834 11.029 22.526 11.029 22.526C10.121 21.906 11.098 21.918 11.098 21.918C12.101 21.988 12.629 22.95 12.629 22.95C13.521 24.48 14.97 24.038 15.539 23.782C15.631 23.135 15.889 22.694 16.175 22.444C13.955 22.191 11.62 21.331 11.62 17.493C11.62 16.4 12.01 15.505 12.649 14.805C12.546 14.552 12.203 13.533 12.747 12.155C12.747 12.155 13.587 11.885 15.497 13.181C16.3128 12.9585 17.1544 12.8452 18 12.844C18.85 12.848 19.705 12.959 20.504 13.181C22.413 11.885 23.251 12.154 23.251 12.154C23.797 13.533 23.453 14.552 23.351 14.805C23.991 15.505 24.379 16.4 24.379 17.493C24.379 21.341 22.04 22.188 19.813 22.436C20.172 22.745 20.491 23.356 20.491 24.291C20.491 25.629 20.479 26.71 20.479 27.038C20.479 27.306 20.659 27.618 21.167 27.52C23.1583 26.8521 24.8893 25.5753 26.1155 23.87C27.3416 22.1648 28.0009 20.1173 28 18.017C28 12.484 23.522 8 18 8Z"
                    fill="black"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default FooterSection;
